export const HOST = "https://flame-api.onrender.com" || window.location.origin;
